var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
var _excluded = ["opened", "linkProps", "items", "onClick", "onLinkClick", "component"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
__name(ownKeys, "ownKeys");
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
__name(_objectSpread, "_objectSpread");
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
__name(_objectWithoutProperties, "_objectWithoutProperties");
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
__name(_objectWithoutPropertiesLoose, "_objectWithoutPropertiesLoose");
import classNames from "classnames";
import React, { useCallback } from "react";
import { ArrowLightIcon } from "@riseart/icons";
import { MenuItem, TYPE as MENU_ITEM_TYPE, TYPE_TO_CLASSNAME } from "../item/Item";
import { VerticalMenuSubmenu } from "./Submenu";
import { menuVerticalItemCls, menuVerticalItemContainerCls, menuVerticalItemOpenedCls, menuVerticalItemIconCls } from "./Menu.less";
import { menuListItemWithImgCls } from "../list/List.less";
function MenuVerticalItem(_ref) {
  var _ref$opened = _ref.opened, opened = _ref$opened === void 0 ? false : _ref$opened, linkProps = _ref.linkProps, items = _ref.items, onClick = _ref.onClick, onLinkClick = _ref.onLinkClick, _ref$component = _ref.component, component = _ref$component === void 0 ? null : _ref$component, restProps = _objectWithoutProperties(_ref, _excluded);
  var hasItems = items && items.length;
  var handleClick = useCallback(function(e) {
    if (typeof onClick === "function") {
      onClick(e, _objectSpread(_objectSpread({
        opened,
        linkProps,
        items,
        onClick,
        onLinkClick,
        component
      }, restProps), {}, {
        hasItems
      }));
    }
  }, [opened, linkProps, items, onLinkClick, component, restProps, onClick, hasItems]);
  return /* @__PURE__ */ React.createElement("li", {
    className: classNames(menuVerticalItemCls, opened && menuVerticalItemOpenedCls, TYPE_TO_CLASSNAME[linkProps.type || MENU_ITEM_TYPE.LINK], linkProps.image && menuListItemWithImgCls)
  }, component ? /* @__PURE__ */ React.createElement("div", {
    className: classNames(menuVerticalItemContainerCls, linkProps.className)
  }, component({
    handleClick,
    onLinkClick,
    linkProps
  })) : /* @__PURE__ */ React.createElement(MenuItem, _extends({}, linkProps, hasItems ? {
    obfuscate: true,
    obflinkProps: {
      stopPropagation: true
    }
  } : null, {
    onClick: handleClick
  })), hasItems ? /* @__PURE__ */ React.createElement(ArrowLightIcon, {
    className: menuVerticalItemIconCls
  }) : null, hasItems ? /* @__PURE__ */ React.createElement(VerticalMenuSubmenu, {
    items,
    onClick: onLinkClick,
    opened
  }) : null);
}
__name(MenuVerticalItem, "MenuVerticalItem");
export {
  MenuVerticalItem
};
